import { Link } from 'react-router-dom';

import {
  FOOTER_TONE,
  FooterCopyright,
  FooterDot,
  FooterLegalNav,
} from '@/shared/components/layout';
import { FOOTER_LEGAL } from '@/shared/constants/app/footerNavigation.ts';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

/**
 * 문서 상세 전용 푸터.
 *
 * 사이트 기본 푸터를 그대로 쓰지 않는 이유는 **길이**다. 문서를 다 읽은 자리에
 * 사업자 정보 한 뭉치가 붙으면, 정작 필요한 다음 행동(문의하기)이 그 아래로
 * 밀린다. 여기서는 **다음 행동 → 필수 링크 → 카피라이트** 순으로 짧게 끝낸다.
 *
 * 사업자 정보(통신판매업 신고번호 등)는 사이버몰 초기화면 쪽 푸터가 계속 지고
 * 있으므로 여기서 빠져도 표시 의무에는 영향이 없다. 다만 대표 연락처는 문의로
 * 이어지는 실질적인 길이라 한 줄 남긴다.
 *
 * 색·링크 목록은 `FOOTER_TONE` / `FooterLegalNav` 로 기본 푸터와 공유한다 —
 * 약관 링크가 한쪽에서만 바뀌는 일이 없어야 한다.
 */
export function DocsFooter() {
  const { company } = FOOTER_LEGAL;

  return (
    <footer
      className={`${FOOTER_TONE.root} ${FOOTER_TONE.edge} px-5 py-9 sm:px-8`}
    >
      <div className="mx-auto max-w-[100rem]">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
          <p className="text-[13.5px] font-semibold text-neutral-800 dark:text-white/85">
            찾으시는 답이 문서에 없었나요?
          </p>
          <Link
            to={PATHS.SUPPORT_INQUIRIES}
            className="rounded-lg border border-neutral-300 px-3.5 py-1.5 text-[13px] font-semibold text-brand-600 transition-colors hover:border-brand-300 dark:border-white/15 dark:text-brand-300"
          >
            1:1 문의하기 →
          </Link>
          <a
            href={`tel:${company.tel.replace(/-/g, '')}`}
            className={`text-[13px] transition-colors ${FOOTER_TONE.meta} ${FOOTER_TONE.metaLink}`}
          >
            {company.tel}
          </a>
          <FooterDot />
          <a
            href={`mailto:${company.emailSupport}`}
            className={`text-[13px] transition-colors ${FOOTER_TONE.meta} ${FOOTER_TONE.metaLink}`}
          >
            {company.emailSupport}
          </a>
        </div>

        <FooterLegalNav className="mt-6" />
        <FooterCopyright className="mt-6" />
      </div>
    </footer>
  );
}
